{
  "EN": {
    "testDetails": "Test details",
    "otherTestName": "Other Test Name",
    "enterTestName": "Please enter the test name.",
    "infoTooltip": "Approximate dates are acceptable. If you're unsure, please default to the 1st of the month.",
    "invalidDate": "Please enter a valid date.",
    "pastDate": "Please enter a past date.",
    "enterScore": "Enter score",
    "scoreAtLeast": "Score must be at least",
    "scoreNotExceed": "Score must not exceed",
    "validScoreBetween": "Please enter a valid score between",
    "and": "and",
    "back": "Back",
    "next": "Next",
    "cancel": "Cancel",
    "apply": "Apply",
    "datePlaceholder": "DD/MM/YYYY",
    "optional": "(Optional)"
  },
  "ID_IND": {
    "testDetails": "Detail tes",
    "otherTestName": "Nama Tes Lain",
    "enterTestName": "Silakan masukkan nama tes.",
    "infoTooltip": "Perkiraan tanggal dapat diterima. Jika Anda tidak yakin, silakan gunakan tanggal 1 bulan tersebut.",
    "invalidDate": "Masukkan tanggal yang valid",
    "pastDate": "Masukkan tanggal yang sudah lewat.",
    "enterScore": "Masukkan skor",
    "scoreAtLeast": "Skor minimal harus",
    "scoreNotExceed": "Skor tidak boleh melebihi",
    "validScoreBetween": "Masukkan skor yang valid antara",
    "and": "dan",
    "back": "Kembali",
    "next": "Berikutnya",
    "cancel": "Batal",
    "apply": "Terapkan",
    "datePlaceholder": "DD/MM/YYYY",
    "optional": "(Opsional)"
  },
  "TH_THA": {
    "testDetails": "รายละเอียดการสอบ",
    "otherTestName": "ชื่อการสอบอื่น",
    "enterTestName": "กรุณากรอกชื่อการสอบ",
    "infoTooltip": "วันที่โดยประมาณสามารถใช้ได้ หากไม่แน่ใจ กรุณาใช้วันที่ 1 ของเดือน",
    "invalidDate": "กรุณากรอกวันที่ที่ถูกต้อง",
    "pastDate": "กรุณากรอกวันที่ในอดีต",
    "enterScore": "กรอกคะแนน",
    "scoreAtLeast": "คะแนนต้องไม่ต่ำกว่า",
    "scoreNotExceed": "คะแนนต้องไม่เกิน",
    "validScoreBetween": "กรุณากรอกคะแนนที่ถูกต้องระหว่าง",
    "and": "และ",
    "back": "ย้อนกลับ",
    "next": "ถัดไป",
    "cancel": "ยกเลิก",
    "apply": "นำไปใช้",
    "datePlaceholder": "DD/MM/YYYY",
    "optional": "(ไม่บังคับ)"
  },
  "KR_KOR": {
    "testDetails": "시험 세부 정보",
    "otherTestName": "기타 시험 이름",
    "enterTestName": "시험명을 입력해 주세요.",
    "infoTooltip": "대략적인 날짜도 괜찮습니다. 확실하지 않으면 해당 월의 1일로 입력해 주세요.",
    "invalidDate": "유효한 날짜를 입력하세요",
    "pastDate": "과거 날짜를 입력해 주세요.",
    "enterScore": "점수 입력",
    "scoreAtLeast": "점수는 최소",
    "scoreNotExceed": "점수는 최대",
    "validScoreBetween": "유효한 점수를 입력해 주세요. 범위:",
    "and": "~",
    "back": "뒤로",
    "next": "다음",
    "cancel": "취소",
    "apply": "적용",
    "datePlaceholder": "DD/MM/YYYY",
    "optional": "(선택 사항)"
  },
  "TW_CHI": {
    "testDetails": "考試詳情",
    "otherTestName": "其他考試名稱",
    "enterTestName": "請輸入考試名稱。",
    "infoTooltip": "大約日期即可。如果不確定，請預設為該月的1日。",
    "invalidDate": "請輸入有效日期",
    "pastDate": "請輸入過去的日期。",
    "enterScore": "輸入分數",
    "scoreAtLeast": "分數至少為",
    "scoreNotExceed": "分數不得超過",
    "validScoreBetween": "請輸入有效分數，範圍為",
    "and": "至",
    "back": "返回",
    "next": "下一步",
    "cancel": "取消",
    "apply": "套用",
    "datePlaceholder": "DD/MM/YYYY",
    "optional": "(選填)"
  },
  "HK_CHI": {
    "testDetails": "考試詳情",
    "otherTestName": "其他考試名稱",
    "enterTestName": "請輸入考試名稱。",
    "infoTooltip": "大約日期即可。如果不確定，請預設為該月的1日。",
    "invalidDate": "請輸入有效日期",
    "pastDate": "請輸入過去的日期。",
    "enterScore": "輸入分數",
    "scoreAtLeast": "分數至少為",
    "scoreNotExceed": "分數不得超過",
    "validScoreBetween": "請輸入有效分數，範圍為",
    "and": "至",
    "back": "返回",
    "next": "下一步",
    "cancel": "取消",
    "apply": "套用",
    "datePlaceholder": "DD/MM/YYYY",
    "optional": "(選填)"
  },
  "HK_ZK": {
    "testDetails": "考试详情",
    "otherTestName": "其他考试名称",
    "enterTestName": "请输入考试名称。",
    "infoTooltip": "大约日期即可。如果不确定，请默认为该月的1日。",
    "invalidDate": "请输入有效日期",
    "pastDate": "请输入过去的日期。",
    "enterScore": "输入分数",
    "scoreAtLeast": "分数至少为",
    "scoreNotExceed": "分数不得超过",
    "validScoreBetween": "请输入有效分数，范围为",
    "and": "至",
    "back": "返回",
    "next": "下一步",
    "cancel": "取消",
    "apply": "应用",
    "datePlaceholder": "DD/MM/YYYY",
    "optional": "(可选)"
  }
}
